<template>
  <div class="vx-row">
    <div class="vx-col md:w-1/1 w-full">
      <vs-input class="w-full mt-4" label="Título" v-model="data.title" name="title" autofocus />

      <vs-input type="file" class="w-full mt-4" label="Imagem" name="imagem" accept="image/*" @change="onImageChange" />

      <div v-show="data.image" class="my-4">
        <img :src="data.image" alt="">
      </div>

      <vs-textarea class="mt-4" rows="16" label="Conteúdo (HTML permitido) OU URL" v-model="data.content" name="content" />

      <div class="vx-row">
        <div class="vx-col md:w-4/12 w-full">
          <vs-select v-model="data.type" name="type" label="Em qual dashboard mostrar" class="w-full mt-4">
            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in types" />
          </vs-select>
        </div>
        <div class="vx-col md:w-4/12 w-full">
          <vs-select v-model="data.status" name="status" label="Situação" class="w-full mt-4">
            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in status" />
          </vs-select>
        </div>
        <div class="vx-col md:w-4/12 w-full">
          <vs-input
            class="w-full mt-4"
            label="Ordem"
            v-model="data.sort"
            name="sort"
            type="number"
            min="0"
            placeholder="Numérico começando de 0"
          />
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col md:w-6/12 w-full mt-2">
          <div class="mb-2">
            Não mostrar em dispositivos que tenham os seguintes planos
          </div>
          <div v-for="plan in plans" :key="plan.id">
            <vs-checkbox v-model="data.plan_id_excluded" :vs-value="plan.id">{{ plan.name }} <small>(id {{ plan.id }})</small></vs-checkbox>
          </div>
        </div>
        <div class="vx-col md:w-6/12 w-full">
          <div class="mb-2">
            Mostrar somente em dispositivos que tenham os seguintes planos
          </div>
          <div v-for="plan in plans" :key="plan.id">
            <vs-checkbox v-model="data.plan_id_included" :vs-value="plan.id">{{ plan.name }} <small>(id {{ plan.id }})</small></vs-checkbox>
          </div>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col md:w-6/12 w-full">
          <Datepicker
            :language="ptBR"
            name="date_start"
            class="w-full mt-4"
            placeholder="Data Início (deixe em branco pra nunca expirar)"
            :use-utc="true"
            format="dd/MM/yyyy"
            v-model="data.date_start"
          />
        </div>

        <div class="vx-col md:w-6/12 w-full">
          <Datepicker
            :language="ptBR"
            name="date_end"
            class="w-full mt-4"
            placeholder="Data Fim (deixe em branco pra nunca expirar)"
            :use-utc="true"
            format="dd/MM/yyyy"
            v-model="data.date_end"
          />
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col md:w-6/12 w-full text-center">
          <vs-button class="mt-4" icon-pack="feather" icon="icon icon-file" @click="save">Salvar</vs-button>
        </div>
        <div class="vx-col md:w-6/12 w-full text-right">
          <vs-button class="mt-4" icon-pack="feather" color="danger" @click="$router.push('/banners')"
          >Cancelar
          </vs-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import {ptBR} from 'vuejs-datepicker/dist/locale'

export default {
  components: {
    Datepicker
  },
  data() {
    return {
      ptBR,
      plans: [],
      data: {
        title: null,
        type: 'ALL',
        image: null,
        status: 1,
        sort: 0,
        plan_id_excluded: [],
        plan_id_included: []
      },
      types: [
        {
          text: 'Todas',
          value: 'ALL'
        },
        {
          text: 'Desktop',
          value: 'DESKTOP'
        },
        {
          text: 'Mobile',
          value: 'MOBILE'
        }
      ],
      status: [
        {
          text: 'Ativo',
          value: 1
        },
        {
          text: 'Inativo',
          value: 0
        }
      ]
    }
  },

  mounted() {
    this.load()

    this.$api
    .get(`/api/v1/backend/plans`)
    .then((response) => {
      this.plans = response.data
    })
    .catch((error) => {
      this.$vs.loading.close()
      this.$vs.notify({
        title: 'Erro',
        text: error.response.data.message,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger'
      })
    })
  },

  methods: {
    load() {
      if (parseInt(this.$route.params.id) > 0) {
        this.$api
        .get(`/api/v1/backend/banner/${this.$route.params.id}`)
        .then((response) => {
          this.$vs.loading.close()
          this.data = response.data
        })
        .catch((error) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Erro',
            text: error.response.data.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
      }
    },
    save() {
      this.$vs.loading()

      this.$api({
        method: this.$route.params.id ? 'PATCH' : 'POST',
        url: this.$route.params.id ? `/api/v1/backend/banner/${this.$route.params.id}` : '/api/v1/backend/banner',
        data: this.data
      })
      .then((response) => {
        this.$vs.loading.close()
        this.data = response.data

        this.$vs.notify({
          text: 'Salvo',
          color: 'success'
        })

        this.$router.push('/banners')
      })
      .catch((error) => {
        this.$vs.loading.close()
        this.$vs.notify({
          title: 'Erro',
          text: Object.values(error.response.data.errors).join('<br>'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
    },
    fileSize(bytes) {
      const i = bytes === 0 ? 0 : Math.floor(Math.log(bytes) / Math.log(1024))
      return (bytes / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i]
    },
    onImageChange(file) {
      const reader = new FileReader()
      reader.readAsDataURL(file.target.files[0])
      reader.onload = e => {
        if (file.target.files[0].size > 200000) {
          this.$vs.notify({
            time: 10000,
            title: 'Erro',
            text: 'O tamanho do arquivo deve ser menor do que 200 kB. O arquivo que você enviou tem ' + this.fileSize(file.target.files[0].size),
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })

          return;
        }

        this.data.image = e.target.result.substring(e.target.result)
      }
    }
  }
}
</script>
